export const PROMO_TYPE_TACTICAL = 'tactical_ads';
export const PROMO_TYPE_NORMAL = 'normal_promo';
